import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import { ExpansionIndicatorContent, ExpansionIndicatorIcon, ExpansionIndicatorRoot } from './style';
import useExpansionIndicatorClassName from './utils/useExpansionIndicatorClassName';
import { EXPANSION_INDICATOR_CLASS_PREFIX, expansionIndicatorContainer, expansionIndicatorContent, expansionIndicatorIcon } from './constants';
import { useTheme } from '../../styling';
export var ExpansionIndicator = function ExpansionIndicator(_ref) {
  var className = _ref.className,
      disabled = _ref.disabled,
      error = _ref.error,
      displaySeparator = _ref.displaySeparator,
      isExpanded = _ref.isExpanded,
      onClick = _ref.onClick,
      tabIndex = _ref.tabIndex,
      restProps = _objectWithoutProperties(_ref, ["className", "disabled", "error", "displaySeparator", "isExpanded", "onClick", "tabIndex"]);

  var theme = useTheme().armor;
  var classOverride = useExpansionIndicatorClassName(EXPANSION_INDICATOR_CLASS_PREFIX, className, disabled, isExpanded);
  return React.createElement(ExpansionIndicatorRoot, Object.assign({
    "data-testid": expansionIndicatorContainer
  }, restProps, {
    className: classOverride.Root,
    disabled: disabled,
    onClick: onClick,
    tabIndex: tabIndex,
    theme: theme
  }), React.createElement(ExpansionIndicatorContent, {
    className: classOverride.Content,
    "data-testid": expansionIndicatorContent,
    error: error,
    displaySeparator: displaySeparator,
    theme: theme
  }, React.createElement(ExpansionIndicatorIcon, {
    className: classOverride.Icon,
    "data-testid": expansionIndicatorIcon,
    disabled: disabled,
    error: error,
    expanded: isExpanded,
    theme: theme
  })));
};
ExpansionIndicator.defaultProps = {
  displaySeparator: false
};